import { Link } from 'react-router-dom';
import User from './User';

import logo_small from 'assets/svg/logos/logo_small.svg';

const Navbar = () => {
  return (
    <div className="sidebar-navbar d-flex flex-column justify-content-between align-items-center">
      <div className="sidebar-navbar--top">
        <div className="sidebar-brand">
          <Link to={'/'}>
            <img src={logo_small} alt="Orca logo" width={34} height={40} />
          </Link>
        </div>
      </div>
      <div className="sidebar-navbar--bottom">
        <User />
      </div>
    </div>
  );
};

export default Navbar;
